module.exports = __webpack_public_path__ + "img/solution3_banner.eef18882.png";